import React, { useEffect, useState } from "react";
import { CLUB_API_SERVICE } from "../../../services/clubApi";
import { IO_API_SERVICE } from "../../../services/ioApi";
import { UseStateValue } from "../../../state";
import { cartToSlotArray } from "../../../util/venues/booking";
import OffersText from "../VenueDetails/OffersText";

export default function OffersList({ venueId, getNextOffer }) {
   const [{ users, cartData, bookableSports, bookableData }, dispatch] = UseStateValue();
   const [offers, setOffers] = useState([]);
   const [loader, setLoader] = useState(false);

   useEffect(() => {
      IO_API_SERVICE.getVenuesOffer(venueId).then(res => {
         if (res.data.requestStatus === 1) {
            setOffers(res?.data);
         } else {
            setOffers(null);
         }
      });
   }, []);

   useEffect(() => {
      // console.log({ cartData });
      if (cartData?.cartMap !== null) {
         setLoader(true);
         let body = {
            total: cartData?.totalGross,
            mobile: users?.userInfo?.mobile || null, // If mobile exists, use it; otherwise, use an empty string
            venueId: bookableData?.venueId,
            slots: cartToSlotArray(cartData.cartMap)
         };
         CLUB_API_SERVICE.fetchCouponsList(body).then(response => {
            if (response?.data?.requestStatus === 1) {
               setLoader(false);
               getNextOffer(response?.data?.data);
            } else {
               setLoader(false);
            }
         });
      }
   }, [cartData]);

   return (
      offers && (
         <div className="w-full px-1 rounded-lg text-xs md:text-sm space-x-3 md:h-12 flex items-center overflow-x-auto mb-6 ">
            {offers?.data?.map((offer, index) => {
               return <OffersText slotScreen={true} key={index} offer={offer} />;
            })}
         </div>
      )
   );
}
